export enum RMS_DIALOG_RESULT {
  REFRESH = 'REFRESH',
  CANCEL = 'CANCEL',
}
